import { Grid } from "@mui/material"
import { useState } from "react"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../ui/TabPanel"
import StudentsTab from "../course/StudentsTab"
import Faculty from "../admin/Faculty"
import { useEffect } from "react"
import ProgramCard from "../cards/ProgramCard"
import AddProgram from "../modals/AddProgram"
import DeleteProgram from "../modals/DeleteProgram"
import { useParams } from "react-router-dom"
import { getProgram } from "../../api"
import { useSnackbar } from "notistack"
import LoadingContent from "../common/LoadingContent"
import Courses from "./Courses"
import BatchesTab from "./BatchesTab"

const Program = () => {
  const [program, setProgram] = useState({})
  const [tabIndex, setTabIndex] = useState(0)
  const changeTab = (_, newValue) => setTabIndex(newValue)
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const { id } = useParams()

  const openEditModal = () => setEditModal(true)
  const closeEditModal = () => setEditModal(false)
  const openDeleteModal = () => setDeleteModal(true)
  const closeDeleteModal = () => setDeleteModal(false)
  const { enqueueSnackbar } = useSnackbar()

  const fetchProgram = () => {
    setLoading(true)
    getProgram(id)
      .then((res) => {
        setProgram(res.data.data)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchProgram()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LoadingContent loading={loading}>
          <ProgramCard
            data={program}
            edit={openEditModal}
            remove={openDeleteModal}
            noView
          />
        </LoadingContent>
      </Grid>
      <Grid item xs={8}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabIndex} onChange={changeTab}>
            <Tab label="Batches" />
            <Tab label="Courses" />
            <Tab label="Faculties" />
            <Tab label="Students" />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <BatchesTab data={program} />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Courses />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <Faculty programData={program} />
        </TabPanel>
        <TabPanel value={tabIndex} index={3}>
          <StudentsTab programData={program} />
        </TabPanel>
      </Grid>
      <AddProgram isOpen={editModal} close={closeEditModal} data={program} />
      <DeleteProgram isOpen={deleteModal} close={closeDeleteModal} data={program} />
    </Grid>
  )
}

export default Program
